<script lang="ts">
    import type {
        ImportAnalyzeContextReasonType,
        ImportAnalyzeResponseType,
    } from '../../ColumnSelectPro/ColumnSettingsApi';
    import ImportAnalyzeRow from './ImportAnalyzeRow.svelte';
    import { currentImport } from '../../../shared/ColumnSelectPro/currentImport';
    import { importFileTypeItems, importMethodTypeItems } from '../Import';
    import ImportAnalyzeResolveLinks from './ImportAnalyzeResolveLinks.svelte';
    import { debug } from '../../../../stores/store';
    import ImportAnalyzeRowInfo from './ImportAnalyzeRowInfo.svelte';
    import WarningColor from '../../../shared/WarningColor.svelte';
    import { _ } from 'svelte-i18n';

    export let analyze: ImportAnalyzeResponseType;
    export let reloadAnalyze: () => void;

    let errors: ImportAnalyzeContextReasonType[] = [];

    let labelImportFileType =
        importFileTypeItems.find(item => item.id === $currentImport?.file_type)?.label || '';

    let labelImportMethodType =
        importMethodTypeItems.find(item => item.id === $currentImport?.import_type)?.label || '';

    function onFinish() {
        reloadAnalyze();
    }
</script>

<div class="import-analyze-container">
    <div class="import-analyze-section">
        <!--        <ImportAnalyzeRowInfo label="Rodzaj importowanych danych" count={labelImportFileType} />-->
        <!--        <ImportAnalyzeRowInfo label="Rodzaj importu" count={labelImportMethodType} />-->
        <ImportAnalyzeRowInfo label={$_('File name')} count={$currentImport?.filename || ''} />
        {#if $currentImport?.history_import}
            <WarningColor>
                <div>{$_('historical_import_auto_completed')}</div>
            </WarningColor>
        {/if}
    </div>
    <div class="import-analyze-section">
        <ImportAnalyzeRow label={$_('jobs_with_addresses')} context={analyze.added_by_address} />
        <ImportAnalyzeRow label={$_('jobs_with_xy_coords')} context={analyze.added_by_coords} />
        <ImportAnalyzeRow label={$_('jobs_with_link_coords')} context={analyze.added_by_xy} />
        <ImportAnalyzeRow
            label={$_('jobs_with_links_to_resolve')}
            context={analyze.needed_to_resolve_from_link}
            displayType="warning"
        >
            <ImportAnalyzeResolveLinks {analyze} {onFinish} bind:errors />
        </ImportAnalyzeRow>

        <ImportAnalyzeRow
            label={$_('total_jobs_in_file')}
            context={analyze.total_uploaded}
        />
        <ImportAnalyzeRow
            label={$_('jobs_ignored_invalid')}
            context={analyze.uploaded_ignored}
            comment={$_('invalid_data_comment')}
            displayType="problem"
            displayReasons={true}
        ></ImportAnalyzeRow>
    </div>
    {#if $debug}
        {JSON.stringify(analyze.uploaded_ignored)}
    {/if}
</div>

<style>
    .import-analyze-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        width: 100%;
        font-size: var(--font-size-tactical-plan);
        row-gap: 35px;
    }
    .import-analyze-section {
        display: flex;
        flex-direction: column;
        row-gap: 10px;
        justify-content: center;
        align-items: flex-start;
        width: 100%;
    }
</style>
